<template>
	<v-container fluid>

		<v-row>
	  	<v-col cols="12" class="pa-0">
	  		<v-toolbar dense class="elevation-0" color="primary" dark >
		      <v-toolbar-title>Curso Inducción</v-toolbar-title>
		      <v-spacer></v-spacer>
		      <v-btn color="white" icon text small :to="{ name: 'GruposAlumnos' }" class="mr-2"><v-icon>mdi-close</v-icon></v-btn>
		    </v-toolbar>
	  	</v-col>
	  </v-row>

	  <v-row>
	  	<v-col cols="12" md="8" class="pt-0 pl-0 pr-0">
	  		<v-card-actions class="px-0 pt-0 pl-0 pr-0">
      		<video
      			v-if="url && verVideo"
      			autoplay
      			id="video" 
      			:src="`${url}`" 
	    			frameborder="0" 
	    			class="pa-2"
	    			allowfullscreen
	    			controls
	    			allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
	         	style="width: 100%; height: 100%; background: #FFFFFF;" allowtransparency="true">
	        </video>

	        <v-card v-else-if="!verEjercicio" width="100%" class="elevation-0 pa-2">
	        	<v-img v-if="tipoCurso == 1" src="@/assets/backgrounds/adultos_fast.png" contain aspect-ratio="2"/>
	        	<v-img v-if="tipoCurso == 2" src="@/assets/backgrounds/adultos_inbi.png" contain aspect-ratio="2"/>
	        	<v-img v-if="tipoCurso == 3" src="@/assets/backgrounds/teens.png" contain aspect-ratio="2"/>
	        </v-card>


      	</v-card-actions>

      	<v-row v-for="(pregunta, i ) in preguntas" :key="i" justify="center" v-if="verEjercicio">
			  	<v-col cols="12" sm="10" md="8" lg="6" >
			  		<v-card class="shadowCard px-0">

			  		  <v-card-title primary-title class="grey--text text-body-1">
			  		    Pregunta {{ pregunta.num_pregunta }}
			  		  </v-card-title>

			  		  <v-img 
			  		  	v-if="pregunta.tiene_imagen == 1" 
			  		  	:src="pathDirecta + pregunta.ruta_imagen"
			  		 	></v-img>
			  		 	<div v-if="pregunta.tiene_audio_pregunta == 1" class="text-center mt-2 pb-0">
			  		 		<audio controls>
								  <source :src="pathDirecta + pregunta.ruta_audio_pregunta" type="audio/mpeg"></audio>
			  		 	</div>

			  		 	
			  		 	<div class="text-h5 my-4 pl-4 pr-4" style="color: #797979" v-if="pregunta.idTipoPregunta == 2">
			  		 		{{ pregunta.pregunta }}
			  		 	</div>

			  		 	<v-card-text v-if="pregunta.pregunta != '' && pregunta.idTipoPregunta == 6" class="text-subtitle-1 my-4 pl-4 pr-4 black--text"> 
			  		 		<b>Instrucciones:</b> {{ pregunta.pregunta }}
			  		 	</v-card-text>	

			  		 	<v-card-text class="text-center pt-0" v-if="pregunta.idTipoPregunta == 2">
						    <v-chip-group
					        v-model="pregunta.eleccion"
					        active-class="primary--text text--accent-4"
					        column
									required
									v-if="!ejercicioResuelto"
					      >
					        <v-chip :value="1" v-if="pregunta.valor1 != '-'">
					          a) {{ pregunta.valor1 }}
					        </v-chip>

					        <v-chip :value="2" v-if="pregunta.valor2 != '-'">
					          b) {{ pregunta.valor2 }}
					        </v-chip>

					        <v-chip :value="3" v-if="pregunta.valor3 != '-'">
					          c) {{ pregunta.valor3 }}
					        </v-chip>

					        <v-chip :value="4" v-if="pregunta.valor4 != '-'">
					          d) {{ pregunta.valor4 }}
					        </v-chip>
					      </v-chip-group>

					      <v-chip-group
									v-else
					        column
					      >
					      	<!-- Pregunta 1 -->
					        <v-chip
					        	v-if="pregunta.respuesta == 1 && pregunta.eleccion == 1 || pregunta.respuesta == 1 && pregunta.eleccion != 1"
					        	:color=" pregunta.respuesta == 1 && pregunta.eleccion == 1 ? 'green': ''"
					        	:dark=" pregunta.respuesta == 1 && pregunta.eleccion == 1 ? true : false ">
					          a) {{ pregunta.valor1 }}
					          <v-icon small right v-if="pregunta.respuesta == 1 && pregunta.eleccion == 1">mdi-check</v-icon>
					        </v-chip>

					        <v-chip
					        	v-if="pregunta.respuesta == 0 && pregunta.correcta == 1"
					        	color="red" dark>
					          a) {{ pregunta.valor1 }} <v-icon small right>mdi-check</v-icon>
					        </v-chip>

					        <v-chip
					        	v-if="pregunta.respuesta == 0 && pregunta.eleccion == 1"
					        	color="primary">
					          a) {{ pregunta.valor1 }} <v-icon small right>mdi-close</v-icon>
					        </v-chip>

					        <v-chip
					        	v-if="pregunta.respuesta == 0 && pregunta.eleccion != 1 && pregunta.correcta != 1"
					        >
					          a) {{ pregunta.valor1 }}
					        </v-chip>

					      	<!-- Pregunta 2 -->
					        <v-chip
					        	v-if="pregunta.respuesta == 1 && pregunta.eleccion == 2 || pregunta.respuesta == 1 && pregunta.eleccion != 2"
					        	:color=" pregunta.respuesta == 1 && pregunta.eleccion == 2 ? 'green': ''"
					        	:dark=" pregunta.respuesta == 1 && pregunta.eleccion == 2 ? true : false ">
					          b) {{ pregunta.valor2 }}
					          <v-icon small right v-if="pregunta.respuesta == 1 && pregunta.eleccion == 2">mdi-check</v-icon>
					        </v-chip>

					        <v-chip
					        	v-if="pregunta.respuesta == 0 && pregunta.correcta == 2"
					        	color="red" dark>
					          b) {{ pregunta.valor2 }} <v-icon small right>mdi-check</v-icon>
					        </v-chip>

					        <v-chip
					        	v-if="pregunta.respuesta == 0 && pregunta.eleccion == 2"
					        	color="primary">
					          b) {{ pregunta.valor2 }} <v-icon small right>mdi-close</v-icon>
					        </v-chip>

					        <v-chip
					        	v-if="pregunta.respuesta == 0 && pregunta.eleccion != 2 && pregunta.correcta != 2"
					        >
					          b) {{ pregunta.valor2 }}
					        </v-chip>

					      	<!-- Pregunta 3 -->
					        <v-chip
					        	v-if="pregunta.respuesta == 1 && pregunta.eleccion == 3 || pregunta.respuesta == 1 && pregunta.eleccion != 3"
					        	:color=" pregunta.respuesta == 1 && pregunta.eleccion == 3 ? 'green': ''"
					        	:dark=" pregunta.respuesta == 1 && pregunta.eleccion == 3 ? true : false ">
					          c) {{ pregunta.valor3 }}
					          <v-icon small right v-if="pregunta.respuesta == 1 && pregunta.eleccion == 3">mdi-check</v-icon>
					        </v-chip>

					        <v-chip
					        	v-if="pregunta.respuesta == 0 && pregunta.correcta == 3"
					        	color="red" dark>
					          c) {{ pregunta.valor3 }} <v-icon small right>mdi-check</v-icon>
					        </v-chip>

					        <v-chip
					        	v-if="pregunta.respuesta == 0 && pregunta.eleccion == 3"
					        	color="primary">
					          c) {{ pregunta.valor3 }} <v-icon small right>mdi-close</v-icon>
					        </v-chip>

					        <v-chip
					        	v-if="pregunta.respuesta == 0 && pregunta.eleccion != 3 && pregunta.correcta != 3"
					        >
					          c) {{ pregunta.valor3 }}
					        </v-chip>

					      	<!-- Pregunta 4 -->
					        <v-chip
					        	v-if="pregunta.respuesta == 1 && pregunta.eleccion == 4 || pregunta.respuesta == 1 && pregunta.eleccion != 4"
					        	:color=" pregunta.respuesta == 1 && pregunta.eleccion == 4 ? 'green': ''"
					        	:dark=" pregunta.respuesta == 1 && pregunta.eleccion == 4 ? true : false ">
					          d) {{ pregunta.valor4 }}
					          <v-icon small right v-if="pregunta.respuesta == 1 && pregunta.eleccion == 4">mdi-check</v-icon>
					        </v-chip>

					        <v-chip
					        	v-if="pregunta.respuesta == 0 && pregunta.correcta == 4"
					        	color="red" dark>
					          d) {{ pregunta.valor4 }} <v-icon small right>mdi-check</v-icon>
					        </v-chip>

					        <v-chip
					        	v-if="pregunta.respuesta == 0 && pregunta.eleccion == 4"
					        	color="primary">
					          d) {{ pregunta.valor4 }} <v-icon small right>mdi-close</v-icon>
					        </v-chip>

					        <v-chip
					        	v-if="pregunta.respuesta == 0 && pregunta.eleccion != 4 && pregunta.correcta != 4"
					        >
					          d) {{ pregunta.valor4 }}
					        </v-chip>

					      </v-chip-group>

			  		 	</v-card-text>	
			  		</v-card>
			  	</v-col>
			  </v-row>

			  <v-row justify="center" v-if="verEjercicio">
			  	<!-- El boton solo debe aparecer siempre y cuando no haya contestado el ejercicio -->
			  	<v-col cols="12" sm="10" md="8" lg="6"  v-if="!ejercicioResuelto && preguntas.length > 0">
			  		<v-card-actions>
			  			<v-btn class="btn-grad text-capitalize" rounded 
			  				large 
			  				dark 
			  				block 
			  				@click="enviarRespuesta()" 
			  				:disabled="disabled"
			  				:loading="loading"
			  			>
			  				<span v-if="!respuestaEnviada">Enviar respuestas</span>
			  				<span v-else>Respuestas enviadas</span>
			  			</v-btn>

			  		</v-card-actions>
			  	</v-col>
			  </v-row>
	  	</v-col>

	  	<v-col cols="12" md="4" class="pt-0 pl-0 pr-0">
	  		<!-- Información básica del grupo -->
	  		<v-card class="elevation-0 overflow-y-auto" v-scroll.self="onScroll" :max-height="tamanioPantalla">
	  			<v-card-text>
						<div class="mb-0 text-h5 colorCurso text-center">
              Contenido del curso
            </div>
	  			</v-card-text>

	  			<!-- Material del curso  -->
	  			<v-container style="max-width: 700px;" >
				    <v-timeline
				      dense
				      clipped
				    >
				      <v-timeline-item
				      	v-for="event in events"
				        :key="event.id"
				        class="mb-4"
				        :color="event.color"
				        :icon="event.icono"
				        icon-color="white"
				        small
				        fill-dot
				      >
				      	<label     v-if="event.line">
				      		<v-icon small left color="green">mdi-circle</v-icon> {{ event.text }}
				      	</label>
				      	<v-progress-linear :value="event.progress" v-if="event.line" :color="event.color"></v-progress-linear>
				      	<v-divider v-if="event.line"></v-divider>

				        <v-row justify="space-between" v-else>
				          <v-col cols="12">
				            {{ event.tipo }}

				            <br/>

				            <v-btn
				            	v-if="event.ver_btn"
						          class="mx-0 mt-2"
						          small
						          tile
						          :color="event.color_btn"
						          dark
						          @click="verMaterial( event )"
						        >
						        	<v-icon small left v-text="event.icon_btn"></v-icon>
						          {{ event.text_btn }}
						        </v-btn>
				          </v-col>

				        </v-row>
				      </v-timeline-item>

				    </v-timeline>
				  </v-container>
	  		</v-card>					
	  	</v-col>
	  </v-row>

	  <!-- Alertas -->
    <Alerta         v-if="respuestaAlerta"         :parametros="parametros"/>
    <Loader         v-if="cargar"                  :loader="loader"/>

	</v-container>
</template>

<script>
	// importar librerías
	import { mapGetters, mapActions } from 'vuex'

	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

  import  validarErrores from '@/mixins/validarErrores.js';


  const  base64 = require('base-64');

	export default {

    mixins:[validarErrores],

	  name: "dashboard-default",

	  data: () => ({
	  	url: null,

	    loader: true,
     	visiblePdf: true,

     	material: null,
     	tipoMaterial:'pdf',

     	pathDirecta: 'https://lms.inbi.mx/',
     	pathViewerPdf: 'https://lms.inbi.mx/recursos/EXCI/viewer',

     	materialClase:[],

     	accesoExci: null,
     	filtermaterialClase: [],

     	events: [],
      input: null,
      nonce: 0,

      scrollInvoked: 0,

      preguntas:[],
			calificacion: 0,
     	calificaciontotal:0,
     	ejercicioResuelto: false,
     	editable: false,
     	verVideo: false,
			verEjercicio: false,
     	respuestaEnviada: false,
     	disabled: false,
     	loading: false,
     	id_evaluacion:0,
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },
			respuestaAlerta:false,
      loader: true,
      cargar: false,
      tipoCurso: 0

	  }),

	  components: {
	    Alerta,
	    Loader
	  },

	  computed:{
	  	...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getRecurso' ]),

	  	tamanioPantalla () {
	      switch (this.$vuetify.breakpoint.name) {
	        case 'xs':
	          return (this.$vuetify.breakpoint.height / 2) + 80
	        break;
	        case 'sm': 
	          return (this.$vuetify.breakpoint.height / 2) - 150
	        break;
	        case 'md':
	          return this.$vuetify.breakpoint.height - 120
	        break;
	        case 'lg':
	          return this.$vuetify.breakpoint.height - 120
	        break;
	        case 'xl':
	          return this.$vuetify.breakpoint.height - 120
	        break;
	      }
    	},

    	timeline () {
        return this.events.slice().reverse()
      },

	  },

	  created(){
	  	this.initialize( )
	  },

	  methods:{
	  	...mapActions( 'login', [ 'abrirRecursosAlumno', 'abrirVentanaRecurso','guardar_id_evaluacion_exci', 'guardar_id_evaluacion_exci_ejercicio'] ),
	  	descargarPdf( ruta ){
	  		window.open(`${this.url}${ruta}`)
	  	},

	  	initialize( ){
        const id_usuario = base64.encode( this.getUsuarioLMS.iderp )
        // Hacemos la petición
        this.$http.get('material.induccion/' + id_usuario).then( response => {
          this.events = response.body.materialGeneral
          this.tipoCurso = response.body.tipo
        }).catch( error =>{
          this.cargar = false
        }).finally(()=>{ this.cargar = false })
      },

	  	verRecursos ( ){
	  		this.cargar = true
	  		const payload = {
					id_usuario: this.getUsuarioLMS.id, 
					id_curso:   this.getGrupo.grupo.id_curso,
					id_nivel:   this.getGrupo.grupo.id_nivel,
					id_grupo:   this.getGrupo.grupo.id,
					lecciones:  this.getGrupo.info_curso.dias_clase,
					tipo:       this.getGrupo.grupo.tipo
	  		}

	  		this.abrirRecursosAlumno( payload ).then(response => { 
	  			this.cargar = false
	  		}).catch( error =>{
    			this.validarError ( error )
    		}).finally( () => { this.cargar = false })
	  	},

	  	verMaterial( material ){

	  		this.disabled     = false
	  		this.loading      = false
	  		this.cargar       = false
	  		this.preguntas    = []
	  		this.calificacion = 0

	  		if( material.tipo_material == 2 ){
	  			this.id_evaluacion = material.idEvaluacion 
	  			this.calificacion  = 100
		  		this.url           = material.url
		  		this.verEjercicio  = false
		  		this.verVideo      = true
		  		
		  		if( material.realizado == false ){
		  			this.videoVisto()
		  		}
		  		
		  		setTimeout(() => {this.visiblePdf = true}, 1000);
	  		}else{
	  			this.verRecurso( material.idEvaluacion )
		  		this.verVideo     = false
	  			this.verEjercicio = true
	  		}
	  	},

      onScroll () {
        this.scrollInvoked++
      },

      verRecurso( id_evaluacion ){
      	this.id_evaluacion = id_evaluacion
	  		this.cargar = true
	  		// Guardamos el id de la evaluacion
		  	const payload = {
		  		id_evaluacion,
		  		id_usuario: this.getUsuarioLMS.id,
		  		id_grupo:   0,
		  		editable:   0
		  	}

		  	// Hacer la ptetición
		  	this.$http.post('recurso.resuelto', payload).then(response => {
		  		this.ejercicioResuelto = response.body.ejercicioResuelto
		  		this.preguntas         = response.body.preguntas
		  		this.calificaciontotal = response.body.calificaciontotal
		  		this.calificacion      = response.body.recursoRescuelto ? response.body.recursoRescuelto.calificacion : 0
		  		this.idResultado       = response.body.recursoRescuelto ? response.body.recursoRescuelto.id : 0
		  		this.disabled = false
		  		this.loading  = false
		  		this.cargar   = false
		  	}).catch( error =>{
		  		this.validarError ( error )
	  		}).finally( () => { this.cargar = false })

		  	this.preguntas.evaluacion = []
      },

      validarDatos () {
	  		this.calificacion = 0
	  		for( const i in this.preguntas){
	  			if( this.preguntas[i].idTipoPregunta == 2 ){
	  				
		  			let { eleccion, num_pregunta, respuesta, opcion_correcta, valor } = this.preguntas[i]
		  			
		  			if( !eleccion ){ 
		  				this.validarErrorDirecto( 'Por favor, contesta la pregunta #' + num_pregunta )
	      			this.respuestaAlerta = true 
		  				return false 
		  			}

		  			if( eleccion == opcion_correcta ){ this.preguntas[i].respuesta = 1; this.calificacion += valor}
		  			else{ this.preguntas[i].respuesta = 0 }
	  			}

	  		}
	  		return true
      },

	  	enviarRespuesta( ){
	  		if( this.validarDatos() ){
		  		const payload = {
		  			id_alumno:         this.getUsuarioLMS.id,
		  			id_grupo:          0,
		  			id_curso:          0,
		  			id_nivel:          0,
		  			id_ciclo:          0,
		  			session:           0,
		  			id_evaluacion:     this.id_evaluacion,
		  			calificacion:      this.calificacion,
		  			calificaciontotal: 100,
		  			preguntas:         this.preguntas
		  		}

		  		this.disabled = true
		  		this.loading  = true
		  		this.cargar   = true

		  		// Hacer la ptetición
		  		this.$http.post('recurso.contestar', payload).then(response => {
			  		this.validarSuccess('Ejercicio realizado')
			  		this.initialize()
			  		this.verRecurso( this.id_evaluacion )
			  	}).catch( error =>{
			  		this.disabled = false
			  		this.loading  = false
			  		this.cargar   = false
			  		this.validarError ( error )
		  		}).finally( () => { this.cargar = false })
		  	}
	  	},


	  	videoVisto( ){
	  		const payload = {
	  			id_alumno:         this.getUsuarioLMS.id,
	  			id_grupo:          0,
	  			id_curso:          0,
	  			id_nivel:          0,
	  			id_ciclo:          0,
	  			session:           0,
	  			id_evaluacion:     this.id_evaluacion,
	  			calificacion:      100,
	  			calificaciontotal: 100,
	  			preguntas:         []
	  		}

	  		// Hacer la ptetición
	  		this.$http.post('recurso.contestar', payload).then(response => {
	  			this.initialize()
		  	}).catch( error =>{
		  		this.validarError ( error )
	  		}).finally( () => { this.cargar = false })
	  	},
	  }
	};
</script>

<style scoped>
	.avatares{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
	}
	
	.colorCurso{
		color: #006093;
	}

	.v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item {
    padding-left: 35px;
	}

	#viewerContainer::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  #viewerContainer > #viewerContainer::-webkit-scrollbar:vertical {
    width: 10px !important;
  }

  #viewerContainer::-webkit-scrollbar:vertical{
    width: 10px !important;
  }

  #viewerContainer::-webkit-scrollbar-button:increment,#viewerContainer::-webkit-scrollbar-button{
    display: none;
  }

  #viewerContainer::-webkit-scrollbar:horizontal{
    height: 10px !important;
  }

  #viewerContainer::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  .v-card::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-card::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  .v-card::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  .v-card::-webkit-scrollbar-button:increment,.v-card::-webkit-scrollbar-button{
    display: none;
  }

  .v-card::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  .v-card::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  .btn-grad {
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}


</style>
